<div class="p-1 mt-1 d-none d-lg-block">
  <h1 class="section-header">
    {{ "UPLOAD_DOCUMENT2" | globalTranslate }}
    {{ submissionType | globalTranslate }} {{ appTrackNum }}
  </h1>
  <hr />
  <p class="static-text">
    {{ "UPLOAD_DOC_TEXT1" | globalTranslate }}
    <strong>{{ "UPLOAD_DOC_TEXT3" | globalTranslate }}</strong>
    {{ "UPLOAD_DOC_TEXT4" | globalTranslate }}
  </p>
  <div class="pb-3 popup">
    <a
      title="{{ 'Types of Proof' | globalTranslate }}"
      tabindex="0"
      (click)="showProofTypes()"
    >
      <span class="pe-2">{{ "Types of Proof" | globalTranslate }}</span>
      <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
    </a>
  </div>
  <div class="row mt-2">
    <div class="col-md-6">
      <span class="text-danger" aria-hidden="true">*</span
      ><label for="proofType" class="label-section">{{
        "PROOF_TYPE" | globalTranslate
      }}</label>
      <select
        class="custom-select-info"
        [attr.aria-label]="'PROOF_TYPE' | globalTranslate"
        [(ngModel)]="proofType"
        (change)="changeProofType()"
        required
      >
        @if (!appealsUpload) {
        <option [ngValue]="null">
          {{ "PICK_AN_OPTION" | globalTranslate }}
        </option>
        } @if (appealsUpload) {
        <option [ngValue]="appealOption">
          {{
            (translatedLang === "en"
              ? appealOption.enDescription
              : appealOption.spDescription
            ) | globalTranslate
          }}
        </option>
        } @for (option of options; track option) {
        <option [ngValue]="option">
          {{
            (translatedLang === "en"
              ? option.enDescription
              : option.spDescription
            ) | globalTranslate
          }}
        </option>
        }
      </select>
      @if (!proofType && proofTypeError) {
      <div class="error-messages position-relative">
        <span class="form-text invalid-tooltip d-block">
          <ng-container>{{ "REQUIRED" | globalTranslate }}</ng-container>
        </span>
      </div>
      }
    </div>
  </div>
  @if (kbDocument && kbDataList) {
  <div class="row pt-3">
    <div class="col-md-6">
      <span class="text-danger" aria-hidden="true">*</span
      ><label for="Ref Id" class="label-section">{{
        "UPLOAD_DOC_STATIC" | globalTranslate
      }}</label>
      <select
        class="custom-select-info"
        [attr.aria-label]="'UPLOAD_DOC_STATIC' | globalTranslate"
        [(ngModel)]="refId"
        required
      >
        <option [ngValue]="null">
          {{ "PICK_AN_OPTION" | globalTranslate }}
        </option>
        @for (option of kbDataList; track option) {
        <option [ngValue]="option">{{ option.name | globalTranslate }}</option>
        }
      </select>
    </div>
  </div>
  } @if (proofType) {
  <div class="pt-3">
    @for (doc of documents; track doc; let i = $index) {
    <div [ngClass]="{ 'upload-document-border p-2 mt-2': i !== 0 && doc.show }">
      <div class="row">
        <div class="col-md-12">
          <span class="text-danger" aria-hidden="true">*</span
          ><label for="docType" class="label-section">{{
            "DOCUMENT_TYPE" | globalTranslate
          }}</label>
          <p
            class="static-text"
            [innerHtml]="'DOCUMENT_TEXT' | globalTranslate"
          ></p>
          @if (isMobileView && !doc.file && i !== 0) {
          <a (click)="close(i)" class="mobile-upload-btn-close"
            ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
            ><i class="fa fa-times-circle" aria-hidden="true"></i
          ></a>
          }
          <select
            class="custom-select-info"
            [attr.aria-label]="'DOCUMENT_TYPE' | globalTranslate"
            [(ngModel)]="doc.docType"
            name="doc.docType"
            (change)="selectedOption(i)"
            required
          >
            <option [ngValue]="null">
              {{ "PICK_AN_OPTION" | globalTranslate }}
            </option>
            @for (option of docOptions; track option) {
            <option [ngValue]="option">
              {{
                (translatedLang === "en"
                  ? option.enDescription
                  : option.spDescription
                ) | globalTranslate
              }}
            </option>
            }
          </select>
          @if (doc.error) {
          <div class="error-messages position-relative">
            <span class="form-text invalid-tooltip d-block">
              <ng-container>{{ "REQUIRED" | globalTranslate }}</ng-container>
            </span>
          </div>
          }
        </div>
        @if (!isMobileView && !doc.file && i !== 0) {
        <div class="col-md-2 offset-md-4">
          <div class="ps-1 pt-1 hover-red upload-btn-close">
            <a (click)="close(i)"
              ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
              ><i class="fa fa-times-circle" aria-hidden="true"></i
            ></a>
          </div>
        </div>
        }
      </div>
      @if (doc.show) {
      <div class="row pt-3">
        <div class="col-md-12">
          <nh-file-upload
            (passFileData)="getFileDetails($event, i)"
          ></nh-file-upload>
        </div>
      </div>
      } @if (doc.file) {
      <div
        class="uploaded-documentname p-2 mt-2 d-flex align-items-center flex-wrap"
      >
        <div class="pe-2 flex-shrink-0">
          <img
            alt=""
            src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
            aria-hidden="true"
            role="presentation"
          />
        </div>
        <div class="me-3 text-truncate min-w-0" style="max-width: 440px">
          <span>{{ doc.file.name }}</span>
        </div>
        <div
          class="hover-red option-lables ms-3 d-inline-flex align-items-center gap-3"
        >
          <a
            class="btn btn-link hover-red d-inline-flex align-items-center text-nowrap p-0"
            tabindex="0"
            (click)="viewPdf(i, 'desktopBrowser')"
          >
            <span>{{ "View" | globalTranslate }}</span>
            <svg
              id="_icons_search-outline"
              data-name="⚛️ icons/search-outline"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <defs>
                <clipPath id="clip-path">
                  <rect id="Background" width="24" height="24" fill="#174a7c" />
                </clipPath>
              </defs>
              <g
                id="Mask_Group_1"
                data-name="Mask Group 1"
                clip-path="url(#clip-path)"
              >
                <path
                  id="Combined_Shape"
                  data-name="Combined Shape"
                  d="M18.232,19.292l-.013-.012-4.927-4.927a8.122,8.122,0,1,1,1.061-1.061l4.927,4.927a.75.75,0,0,1-1.049,1.073ZM1.5,8.114A6.614,6.614,0,1,0,8.114,1.5,6.621,6.621,0,0,0,1.5,8.114Z"
                  transform="translate(2.25 2.25)"
                  fill="#174a7c"
                />
              </g>
            </svg>
          </a>
          <a
            id="remove"
            tabindex="0"
            class="btn btn-link hover-red d-inline-flex align-items-center text-nowrap p-0"
            (click)="removeItem(i)"
          >
            <span>{{ "Remove" | globalTranslate }}</span>
            <nh-remove-svg></nh-remove-svg>
          </a>
        </div>
      </div>
      }
    </div>
    }
  </div>
  } @if (proofType) {
  <div class="d-flex align-items-start mt-3">
    <div class="ms-2">
      <button
        id="addAnother"
        (click)="addAnother()"
        class="btn btn-outline-secondary btn-add-another align-items-center"
        [hidden]="error"
        [attr.aria-label]="'ADD_ANOTHER' | globalTranslate"
      >
        {{ "ADD_ANOTHER" | globalTranslate }}
        <svg
          id="_icons_add-circle-outline"
          data-name="⚛️ icons/add-circle-outline"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            id="Combined_Shape"
            data-name="Combined Shape"
            d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
            transform="translate(2.25 2.25)"
            fill="#174a7c"
          />
        </svg>
      </button>
    </div>
    <div class="ms-2">
      <button
        [hidden]="error || showCZPRmessage"
        routerLinkActive="active"
        (click)="submitDocuments('desktop')"
        id="continue"
        class="btn btn-secondary"
      >
        {{ "SUBMIT" | globalTranslate }}
      </button>
    </div>
  </div>
  } @if (showCZPRmessage) {
  <div style="border: 0px solid #f5e0af; margin-top: 15px">
    {{ "UPLOAD_DOC_TEXT2" | globalTranslate }}
  </div>
  }
</div>

<div class="p-1 mt-1 nh-table-mobile d-lg-none">
  @if (!successDocUpload) {
  <div>
    <h2 class="section-header">
      {{ "UPLOAD_DOCUMENT2" | globalTranslate }}
      {{ submissionType | globalTranslate }} {{ appTrackNum }}
    </h2>
    <hr />
    <p class="static-text">
      {{ "UPLOAD_DOC_TEXT1" | globalTranslate }}
      <strong>{{ "UPLOAD_DOC_TEXT3" | globalTranslate }}</strong>
      {{ "UPLOAD_DOC_TEXT4" | globalTranslate }}
    </p>
    <div tabindex="0" (click)="showProofTypes()" class="pb-3 popup">
      {{ "Types of Proof" | globalTranslate }}
      <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
    </div>
    <div class="row mt-2">
      <div class="col-md-6">
        <span class="text-danger" aria-hidden="true">*</span
        ><span class="visually-hidden">required </span
        ><label for="proofType" class="label-section">{{
          "PROOF_TYPE" | globalTranslate
        }}</label>
        <select
          class="custom-select-info"
          [attr.aria-label]="'PROOF_TYPE' | globalTranslate"
          [(ngModel)]="proofType"
          (change)="changeProofType()"
          required
        >
          @if (!appealsUpload) {
          <option [ngValue]="null">
            {{ "PICK_AN_OPTION" | globalTranslate }}
          </option>
          } @if (appealsUpload) {
          <option [ngValue]="appealOption">
            {{
              (translatedLang === "en"
                ? appealOption.enDescription
                : appealOption.spDescription
              ) | globalTranslate
            }}
          </option>
          } @for (option of options; track option) {
          <option [ngValue]="option">
            {{
              (translatedLang === "en"
                ? option.enDescription
                : option.spDescription
              ) | globalTranslate
            }}
          </option>
          }
        </select>
        @if (!proofType && proofTypeError) {
        <div class="error-messages position-relative">
          <span class="form-text invalid-tooltip d-block">
            <ng-container>{{ "REQUIRED" | globalTranslate }}</ng-container>
          </span>
        </div>
        }
      </div>
    </div>
    @if (kbDocument && kbDataList) {
    <div class="row pt-3">
      <div class="col-md-6">
        <span class="text-danger" aria-hidden="true">*</span
        ><label for="Ref Id" class="label-section">{{
          "UPLOAD_DOC_STATIC" | globalTranslate
        }}</label>
        <select
          class="custom-select-info"
          [attr.aria-label]="'UPLOAD_DOC_STATIC' | globalTranslate"
          [(ngModel)]="refId"
          required
        >
          <option [ngValue]="null">
            {{ "PICK_AN_OPTION" | globalTranslate }}
          </option>
          @for (option of kbDataList; track option) {
          <option [ngValue]="option">{{ option.name }}</option>
          }
        </select>
      </div>
    </div>
    } @if (proofType) {
    <div class="pt-3">
      @for (doc of diffDocTypes; track doc; let i = $index) {
      <div
        [ngClass]="{ 'upload-document-border p-2 mt-2': i !== 0 && doc.show }"
      >
        <div class="row">
          <div class="col-md-12">
            <span class="text-danger" aria-hidden="true">*</span
            ><label for="docType" class="label-section">{{
              "DOCUMENT_TYPE" | globalTranslate
            }}</label>
            <p
              class="static-text"
              [innerHtml]="'DOCUMENT_TEXT' | globalTranslate"
            ></p>
            <select
              class="custom-select-info"
              [attr.aria-label]="'DOCUMENT_TYPE' | globalTranslate"
              [(ngModel)]="doc.docType"
              name="doc.docType"
              (change)="selectedOptionMobile(i)"
              required
            >
              <option [ngValue]="null">
                {{ "PICK_AN_OPTION" | globalTranslate }}
              </option>
              @for (option of docOptions; track option) {
              <option [ngValue]="option">
                {{
                  (translatedLang === "en"
                    ? option.enDescription
                    : option.spDescription
                  ) | globalTranslate
                }}
              </option>
              }
            </select>
            @if (doc.error) {
            <div class="error-messages position-relative">
              <span class="form-text invalid-tooltip d-block">
                <ng-container>{{ "REQUIRED" | globalTranslate }}</ng-container>
              </span>
            </div>
            }
          </div>
          @if (!doc.file && i !== 0 && doc.docType?.code && displayUpload) {
          <div class="col-md-2 offset-md-4">
            <div
              class="row ps-3 pt-1 hover-red upload-btn-close"
              style="float: right"
            >
              <a (click)="closeMobile()"
                ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
                ><i class="fa fa-times-circle" aria-hidden="true"></i
              ></a>
            </div>
          </div>
          }
        </div>
        @if (doc.show && doc.docType?.code) {
        <div class="row pt-3">
          <div class="col-md-12">
            <nh-mobile-file-upload
              (passFileData)="getFileDetailsMobile($event, i)"
              (fileUploadStarted)="getFileProgress($event)"
              [displayLoading]="displayLoading"
            ></nh-mobile-file-upload>
          </div>
        </div>
        } @if (doc.file) {
        <div class="d-flex align-items-center p-3">
          <div class="row uploaded-documentname">
            <div class="pe-2 file-icon">
              <img
                alt=""
                src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
                aria-hidden="true"
                role="presentation"
              />
            </div>
            @if (doc.commonItems?.length > 1) {
            <div class="file-name" style="max-width: 440px">
              <span
                >{{ doc.commonItems.length }}
                {{ "DOCUMENTS_UPLOADED" | globalTranslate }}</span
              >
            </div>
            } @if (doc.commonItems.length === 1) {
            <div class="file-name" style="max-width: 440px">
              <span>1 {{ "DOCUMENT_ONE_UPLOADED" | globalTranslate }}</span>
            </div>
            }
            <div class="hover-red option-lables">
              <a
                id="edit"
                tabindex="0"
                class="btn btn-link hover-red"
                (click)="onEdit(i, doc)"
              >
                <span>{{ "EDIT_OR_VIEW" | globalTranslate }} </span>
                <svg
                  id="_icons_search-outline"
                  data-name="⚛️ icons/search-outline"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <defs>
                    <clipPath id="clip-path">
                      <rect
                        id="Background"
                        width="24"
                        height="24"
                        fill="#174a7c"
                      />
                    </clipPath>
                  </defs>
                  <g
                    id="Mask_Group_1"
                    data-name="Mask Group 1"
                    clip-path="url(#clip-path)"
                  >
                    <path
                      id="Combined_Shape"
                      data-name="Combined Shape"
                      d="M18.232,19.292l-.013-.012-4.927-4.927a8.122,8.122,0,1,1,1.061-1.061l4.927,4.927a.75.75,0,0,1-1.049,1.073ZM1.5,8.114A6.614,6.614,0,1,0,8.114,1.5,6.621,6.621,0,0,0,1.5,8.114Z"
                      transform="translate(2.25 2.25)"
                      fill="#174a7c"
                    />
                  </g>
                </svg>
              </a>
              <a
                id="remove"
                tabindex="0"
                class="btn btn-link hover-red"
                (click)="removeItemMobile(i)"
              >
                <span>{{ "Remove" | globalTranslate }}</span>
                <nh-remove-svg></nh-remove-svg>
              </a>
            </div>
          </div>
        </div>
        }
      </div>
      } @if (displayLoading) {
      <div class="row uploaded-documentname">
        <div class="col-8">
          <span class="pe-2 file-icon"
            ><img
              alt=""
              src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
              aria-hidden="true"
              role="presentation"
          /></span>
          <span class="file-name" style="max-width: 440px">{{ docName }}</span>
        </div>
        <div class="col-4">
          <div class="option-lables">
            <img
              src="../../../../../../assets/images/⚛️ File_Uploader_Loader.svg"
            />
          </div>
        </div>
      </div>
      }
    </div>
    } @if (proofType) {
    <div class="align-items-start mt-3">
      <div class="ms-2">
        <button
          id="addAnother"
          (click)="addAnotherMobile()"
          class="btn btn-outline-secondary btn-add-another align-items-center"
          [hidden]="error"
          [attr.aria-label]="'ADD_ANOTHER' | globalTranslate"
        >
          {{ "ADD_ANOTHER" | globalTranslate }}
          <svg
            id="_icons_add-circle-outline"
            data-name="⚛️ icons/add-circle-outline"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
              transform="translate(2.25 2.25)"
              fill="#174a7c"
            />
          </svg>
        </button>
      </div>
      <div class="ms-2">
        <button
          [hidden]="error || showCZPRmessage"
          routerLinkActive="active"
          (click)="submitDocuments('mobileBrowser')"
          id="continue"
          class="btn btn-secondary"
        >
          {{ "SUBMIT" | globalTranslate }}
        </button>
      </div>
    </div>
    } @if (showCZPRmessage) {
    <div style="border: 0px solid #f5e0af; margin-top: 15px">
      {{ "UPLOAD_DOC_TEXT2" | globalTranslate }}
    </div>
    }
  </div>
  }
  <!-- new screen chanages start -->
  @if (successDocUpload) {
  <div class="col-md-12">
    <span [innerHTML]="'REVAMP_MOBILEDOC_STATIC1' | globalTranslate"></span
    ><br /><br />
    @if (!changeType) {
    <h2
      class="section-header mt-0 ms-0"
      style="text-align: center; padding-top: 0px"
    >
      {{ currentDocType | globalTranslate }}
    </h2>
    } @if (!changeType) {
    <div class="ms-0" style="text-align: center">
      <button
        (click)="clickChangeType()"
        id="changeType"
        class="btn btn-secondary"
        style="
          min-width: 200px;
          height: 38px;
          font: normal normal bold 18px / 20px Open Sans !important;
        "
      >
        {{ "CHANGE_TYPE" | globalTranslate }}
      </button>
    </div>
    } @if (changeType) {
    <div class="col-md-12">
      <span class="text-danger" aria-hidden="true">*</span
      ><label class="label-section">{{
        "DOCUMENT_TYPE" | globalTranslate
      }}</label>
      <select
        class="custom-select-info"
        [attr.aria-label]="'DOCUMENT_TYPE' | globalTranslate"
        [(ngModel)]="diffDocTypes[currentI].docType"
        name="diffDocTypes[currentI].docType"
        (change)="selectedOptionMobile(currentI)"
        required
      >
        <option [ngValue]="null">
          {{ "PICK_AN_OPTION" | globalTranslate }}
        </option>
        @for (option of docOptions; track option) {
        <option [ngValue]="option">
          {{
            (translatedLang === "en"
              ? option.enDescription
              : option.spDescription
            ) | globalTranslate
          }}
        </option>
        }
      </select>
      @if (diffDocTypes[currentI]?.error) {
      <div class="error-messages position-relative">
        <span class="form-text invalid-tooltip d-block">
          <ng-container>{{ "REQUIRED" | globalTranslate }}</ng-container>
        </span>
      </div>
      }
    </div>
    }
    <!-- uploaded Files -->
    <div class="row upload_doc">
      @for (filteredDoc of filteredDocs; track filteredDoc; let i = $index) {
      <div
        [ngClass]="{
          'upload-document-border p-2 mt-2': i !== 0 && filteredDoc.show
        }" class="document-upload"
      >
        @if (filteredDoc.file) {
        <div class="col d-flex align-items-center p-3">
          @if (filteredDoc.file.type !== 'application/pdf') {
          <div class="preview-container">
            <img
              (click)="viewPdf(i, 'mobileBrowser')"
              [src]="filteredDoc.filePreview"
              alt="File Preview"
              class="preview"
            />
            <div
              class="hover-red"
              [ngClass]="{ 'lang-sp': translatedLang === 'sp' }"
            >
              <a
                id="remove"
                tabindex="0"
                class="btn btn-link hover-red"
                (click)="removeItemMobile(i)"
              >
                <span>{{ "Remove" | globalTranslate }}</span>
                <nh-remove-svg></nh-remove-svg>
              </a>
            </div>
          </div>
          } @if (filteredDoc.file.type === 'application/pdf') {
          <div class="preview-container">
            <pdf-viewer
              (click)="viewPdf(i, 'mobileBrowser')"
              [src]="filteredDoc.filePreview"
              [render-text]="true"
              [original-size]="false"
              class="preview"
            ></pdf-viewer>
            <div
              class="hover-red"
              [ngClass]="{ 'lang-sp': translatedLang === 'sp' }"
            >
              <a
                id="remove"
                tabindex="0"
                class="btn btn-link hover-red"
                (click)="removeItemMobile(i)"
              >
                <span>{{ "Remove" | globalTranslate }}</span>
                <nh-remove-svg></nh-remove-svg>
              </a>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    @if (displayLoading) {
    <div class="row uploaded-documentname">
      <div class="col-8">
        <span class="pe-2 file-icon"
          ><img
            alt=""
            src="../../../../../../assets/images/⚛️ icons-document-attach-outline.svg"
            aria-hidden="true"
            role="presentation"
        /></span>
        <span class="file-name" style="max-width: 440px">{{ docName }}</span>
      </div>
      <div class="col-4">
        <div class="option-lables">
          <img
            src="../../../../../../assets/images/⚛️ File_Uploader_Loader.svg"
          />
        </div>
      </div>
    </div>
    } @if (showClose && displayUpload) {
    <a (click)="closeMobile()" class="mobile-upload-btn-close"
      ><span class="pe-2">{{ "CLOSE" | globalTranslate }}</span
      ><i class="fa fa-times-circle" aria-hidden="true"></i
    ></a>
    }<br />
    @if (showClose) {
    <div class="pt-3">
      <div class="col-md-12">
        <nh-mobile-file-upload
          (passFileData)="getFileDetailsMobile($event, currentI)"
          (fileUploadStarted)="getFileProgress($event)"
          [displayLoading]="displayLoading"
        ></nh-mobile-file-upload>
      </div>
    </div>
    }
    <div class="row col-md-12">
      <div class="ms-2" [attr.aria-label]="'ADD_PAGE_2' | globalTranslate">
        <button
          id="addAnother2"
          (click)="addAnotherMobile()"
          class="btn btn-outline-secondary btn-add-another"
          style="
            border-radius: 4px;
            border: 1px solid #132742;
            color: #132742;
            background: #fff;
            text-transform: none;
            font: 700 18px / 27px Open Sans !important;
          "
          [ngClass]="{ 'lang-sp': translatedLang === 'sp' }"
          [hidden]="error"
        >
          {{ "ADD_PAGE_2" | globalTranslate }}
          <svg
            id="_icons_add-circle-outline"
            data-name="⚛️ icons/add-circle-outline"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path
              id="Combined_Shape"
              data-name="Combined Shape"
              d="M0,9.75A9.75,9.75,0,1,1,9.75,19.5,9.761,9.761,0,0,1,0,9.75Zm1.5,0A8.25,8.25,0,1,0,9.75,1.5,8.259,8.259,0,0,0,1.5,9.75ZM9,13.514V10.5H6A.75.75,0,0,1,5.985,9H9V6a.75.75,0,0,1,1.5-.015V9h3a.75.75,0,0,1,.014,1.5H10.5v3a.75.75,0,0,1-1.5.014Z"
              transform="translate(2.25 2.25)"
              fill="#174a7c"
            />
          </svg>
        </button>
      </div>
      @if (successDocUpload) {
      <div class="ms-2">
        <button
          [hidden]="error"
          (click)="onContinue()"
          id="continue2"
          class="btn btn-secondary"
        >
          {{ "CONTINUE_1" | globalTranslate }}
        </button>
      </div>
      }
    </div>
    @if (showCZPRmessage) {
    <div style="border: 0px solid #f5e0af; margin-top: 15px">
      {{ "UPLOAD_DOC_TEXT2" | globalTranslate }}
    </div>
    }
  </div>
  }
</div>
